interface ContentSection01Props {
  sectionId?: string;
  sectionIdText?: string;
  title: string;
  description?: string;
  subtitle?: string;
  items?: string[];
  image: string;
  imageAlt?: string;
  imageFirst?: boolean;
  buttonText?: string;
  buttonLink?: string;
}

export const ContentSection01 = ({
  sectionId,
  sectionIdText,
  title,
  description,
  subtitle,
  items = [],
  image,
  imageAlt = 'content-image',
  imageFirst = false,
  buttonText,
  buttonLink
}: ContentSection01Props) => {
  return (
    <section
      id={sectionId}
      className="pt--100 pt-[100px] lg:max-xl:pt-[80px] md:max-lg:pt-[70px] ct-01 content-section division"
    >
      <div className="container">
        {/* SECTION CONTENT (ROW) */}
        <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] items-center">
          {/* TEXT BLOCK */}
          <div
            className={`md:w-6/12 lg:max-xl:w-6/12 xl:w-6/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full ${
              imageFirst
                ? 'order-last order-md-2 md:max-lg:order-2 lg:max-xl:order-2 xl:order-2'
                : ''
            }`}
          >
            <div className="txt-block left-column wow fadeInRight">
              {/* Section ID */}
              {sectionIdText && (
                <span className="section-id block !text-[0.85rem] leading-none !font-bold !tracking-[0.5px] uppercase xl:!mb-[35px] lg:max-xl:!mb-[30px] md:max-lg:!mb-[25px] sm:max-md:!mb-[25px] font-Jakarta">
                  {sectionIdText}
                </span>
              )}
              {/* Title */}
              <h2 className="s-46 w--700 xl:!text-[2.875rem] lg:max-xl:!text-[2.625rem] md:max-lg:!text-[2.35294rem] sm:max-md:!text-[2.25rem] xsm:max-sm:!text-[1.8125rem] !font-bold leading-[1.25] font-Jakarta sm:max-md:!leading-[1.35] xsm:max-sm:!leading-[1.35] xl:!mb-[26px] lg:max-xl:!mb-[20px] md:max-lg:!mb-[15px] sm:max-md:!mb-[20px] xsm:max-sm:!mb-[15px]">
                {title}
              </h2>
              {/* Text */}
              {description && <p>{description}</p>}
              {/* Small Title */}
              {subtitle && (
                <h5 className="s-24 w--700 xl:!text-[1.5rem] lg:max-xl:!text-[1.375rem] md:max-lg:!text-[1.470588rem] sm:max-md:!text-[1.625rem] xsm:max-sm:!text-[1.4375rem] !font-bold leading-[1.35] font-Jakarta sm:max-md:!leading-[1.4] xsm:max-sm:!leading-[1.4] xl:!mb-[20px] lg:max-xl:!mb-[18px] md:max-lg:!mb-[18px] sm:max-md:!mb-[18px]">
                  {subtitle}
                </h5>
              )}
              {/* List */}
              {items.length > 0 && (
                <ul className="simple-list">
                  {items.map((item, index) => (
                    <li key={index} className="list-item">
                      <p className={index === items.length - 1 ? '!mb-0' : ''}>
                        {item}
                      </p>
                    </li>
                  ))}
                </ul>
              )}
              {/* Button */}
              {buttonText && buttonLink && (
                <a
                  href={buttonLink}
                  className="btn btn-sm r-04 !rounded-[4px] btn--theme hover--tra-black mt-[25px] lg:max-xl:!mt-[22px] md:max-lg:!mt-[15px] sm:max-md:!mt-[18px] xsm:max-sm:!mt-[18px]"
                >
                  {buttonText}
                </a>
              )}
            </div>
          </div>
          {/* END TEXT BLOCK */}
          {/* IMAGE BLOCK */}
          <div
            className={`md:w-6/12 lg:max-xl:w-6/12 xl:w-6/12 w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full ${
              imageFirst
                ? 'order-first order-md-2 md:max-lg:order-2 lg:max-xl:order-2 xl:order-2'
                : ''
            }`}
          >
            <div
              className={`img-block !text-center ${
                imageFirst ? 'right-column' : 'left-column'
              } wow fadeInLeft ${
                imageFirst
                  ? 'ml-[30px] lg:max-xl:ml-[5px] md:max-lg:ml-0 sm:max-md:!mx-[3%] xsm:max-sm:!m-[0_2%_35px]'
                  : 'mr-[30px] lg:max-xl:mr-[5px] md:max-lg:mr-0 sm:max-md:!mx-[3%] xsm:max-sm:!m-[0_2%_35px]'
              }`}
            >
              <img className="img-fluid" src={image} alt={imageAlt} />
            </div>
          </div>
        </div>
        {/* END SECTION CONTENT (ROW) */}
      </div>
      {/* End container */}
    </section>
  );
};
